import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import { Box } from '@mui/material';

// Icons
import { Home, LocationCity, MarkunreadMailbox } from '@mui/icons-material';

// Styles
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@emotion/react';

// Store

// Components
import CmtGridView from '@coremat/CmtGridView';
import GridContainer from '@jumbo/components/GridContainer';
import CmtCardContent from '@coremat/CmtCard/CmtCardContent';
import CmtCardHeader from '@coremat/CmtCard/CmtCardHeader';
import CmtCard from '@coremat/CmtCard';
import { useDealer } from 'services/Data/DealerServices';
import { translate } from '@acnb/CustomComponents/DropdownItem/Translate';

// Other

const useStyles = makeStyles(() => ({
  bioTitle: {
    marginBottom: 16,
  },
}));

const ProfileDealerAddress = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const classes = useStyles();

  const { data: dealer } = useDealer();

  let renderData = useMemo(
    () => [
      { title: t('address'), desc: dealer?.civicNumber ?? 'N/A', icon: <Home /> },
      { title: t('city'), desc: dealer?.city ?? 'N/A', icon: <LocationCity /> },
      { title: t('postalCode'), desc: dealer?.postalCode ?? 'N/A', icon: <MarkunreadMailbox /> },
      {
        title: t('province'),
        desc: translate({ label: dealer?.region?.label, t }) ?? 'N/A',
        icon: <MarkunreadMailbox />,
      },
    ],
    [dealer?.city, dealer?.civicNumber, dealer?.postalCode, dealer?.region, t],
  );

  return (
    <Box mb={6}>
      <CmtCard className={classes.cardRoot}>
        <CmtCardHeader
          style={{ minHeight: '60px' }}
          separator={{
            color: theme.palette.borderColor.dark,
          }}
          title={t('dealerAddress')}
        />
        <CmtCardContent>
          <CmtGridView
            itemPadding={24}
            responsive={{
              xs: 1,
              sm: 2,
              md: 3,
              lg: 3,
              xl: 3,
            }}
            data={renderData}
            renderRow={(item, index) => (
              <Box display="flex" alignItems="center" key={index}>
                {item.icon}
                <Box ml={3}>
                  <Box fontSize={12} color="text.secondary">
                    {item.title}
                  </Box>
                  <Box className={classes.columnRoot}>{item.desc ? item.desc : item.list}</Box>
                </Box>
              </Box>
            )}
          />
          <GridContainer spacing={0} className="mt-5"></GridContainer>
        </CmtCardContent>
      </CmtCard>
    </Box>
  );
};

export default ProfileDealerAddress;
